import { Box, Tag } from '@nimbus-ds/components';
import { Button, Popover } from '@tiendanube/components';
import { EllipsisIcon } from '@tiendanube/icons';
import LinkPopover from 'commons/components/LinkPopover';
import { useTranslationCommon } from 'commons/hooks';
import { ActionProp } from '../../../types';

function ActionPopover({ actions }: { actions: ActionProp[] }): JSX.Element {
  const t = useTranslationCommon();
  const labelMoreOptions = t('moreOptions');
  return (
    <Popover
      name="moreOptions"
      renderInitiator={(onClick) => (
        <Button onClick={onClick} icon={EllipsisIcon}>
          {labelMoreOptions}
        </Button>
      )}
    >
      {actions.map((action) => (
        <LinkPopover
          key={action.children}
          icon={action.icon}
          disabled={action.disabled}
          onClick={action.onClick}
          spinner={action.spinner}
          iconPosition={action.iconPosition}
          appearance={action.appearance}
          pro={action.pro}
        >
          <Box display="flex" justifyContent="space-between" gap="1">
            {action.children}
            {action.isNew && <Tag appearance="primary">{t('menu.new')}</Tag>}
          </Box>
        </LinkPopover>
      ))}
    </Popover>
  );
}

export default ActionPopover;
